// extracted by mini-css-extract-plugin
module.exports = {"shippingOption":"SendOptions_shippingOption__22dOE","OptionsForSend":"SendOptions_OptionsForSend__3IKn3","successWrap":"SendOptions_successWrap__1Yk0D"};